import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { Image } from 'expo-image';

import {
  getKlipyGifAspectRatio,
  getKlipyGifPreview,
} from '@/components/ui/media/providers/klipy/klipyGifUtils';
import type { IKlipyGif } from '@/services/media/providers/klipy/types';

interface IKlipyGifGridItemProps {
  gif: IKlipyGif;
  onPress: (gif: IKlipyGif) => void;
}

export function KlipyGifGridItem({ gif, onPress }: IKlipyGifGridItemProps) {
  const preview = getKlipyGifPreview(gif);
  const aspectRatio = getKlipyGifAspectRatio(gif);
  const accessibilityLabel = gif.title?.trim() || undefined;

  return (
    <TouchableOpacity
      activeOpacity={0.85}
      onPress={() => onPress(gif)}
      accessibilityLabel={accessibilityLabel}
      className="w-full overflow-hidden rounded-xl bg-background-100"
      style={{ aspectRatio }}>
      {preview?.url ? (
        <Image
          source={{ uri: preview.url }}
          style={{ width: '100%', height: '100%' }}
          contentFit="cover"
          recyclingKey={gif.slug}
        />
      ) : (
        <View className="aspect-square w-full bg-background-200" />
      )}
    </TouchableOpacity>
  );
}
